module.exports = __webpack_public_path__ + "img/35.52776718.jpg";